/* START GENAI@GHCOPILOT */
import { getAppInstance } from 'common/browser';
import { CoFEnrollResponse, FetchCoFEnrollOptions } from 'types/api/cof-enroll';
import { FetchResponse } from 'types/fetch';
/* START GENAI@GHCOPILOT */
import endpoints from '../endpoints';
import fetchReq from '../fetch';
/* END GENAI@GHCOPILOT */

export default function fetchEnrollCard({
  /* START GENAI@GHCOPILOT */
  accessToken,
  /* END GENAI@GHCOPILOT */
  idToken,
  apikey,
  enrollmentReferenceData,
  serviceId,
  srcCorrelationId,
  /* START GENAI@GHCOPILOT */
  srcTokenRequestData,
  srciTransactionId
  /* END GENAI@GHCOPILOT */
}: FetchCoFEnrollOptions): FetchResponse<CoFEnrollResponse> {
  /* START GENAI@GHCOPILOT */
  const url: string = endpoints.orchestrator.enrollCardCoF;
  /* END GENAI@GHCOPILOT */
  const headers: Record<string, string> = {};

  if (accessToken) {
    headers.access_token = accessToken;
  } else if (idToken) {
    headers.id_token = idToken;
  }

  const body = {
    appInstance: {
      userAgent: getAppInstance()
    },
    enrollmentReferenceData,
    serviceId,
    srcClientId: apikey,
    srcCorrelationId,
    srciTransactionId,
    /* START GENAI@GHCOPILOT */
    srcTokenRequestData
    /* END GENAI@GHCOPILOT */
  };

  return fetchReq({
    body,
    headers,
    mark: 'cof_enroll',
    method: 'POST',
    url
  });
}

/* END GENAI@GHCOPILOT */
